<template>
  <Teleport to="body">
    <div class="fixed inset-0 z-50 overflow-y-auto bg-black/60 flex justify-center p-2 sm:p-5"
      @click.self="closeDialog(false)">
      <div class="w-full md:w-8/12 lg:w-4/12 xl:w-5/12 my-auto" @click.self="closeDialog(false)">

        <div class="p-0 bg-gray-50 shadow-xl border border-gray-200 rounded-md text-center">

          <div class="flex flex-col w-full text-black">

            <BlockUI :visible="blocked">

              <div v-if="blocked" class="absolute inset-0 flex items-center justify-center z-50 bg-black/20">
                <ProgressSpinner style="width: 50px; height: 50px" strokeWidth="5" fill="transparent"
                  animationDuration=".5s" />
              </div>

              <div class="flex flex-col w-full rounded-t-md p-3 bg-gradient-to-r from-[#424c42] to-[#647064]">
                <div>
                  <font-awesome-icon :icon="['fas', 'fa-lock']" class="w-6 h-6 text-white" />
                </div>
                <div
                  class="font-semibold text-white text-sm md:text-2xl truncate whitespace-nowrap overflow-hidden text-ellipsis">
                  AGENDA
                </div>
                <div
                  class="font-semibold text-white text-sm md:text-xl truncate whitespace-nowrap overflow-hidden text-ellipsis flex flex-col">
                  <span class="tracking-wider">{{ formatDate(detalleAgenda.cronograma.fecha, 'dd/MM/yyyy') }}</span>
                  <span>{{ detalleAgenda.cronograma.horaDesde }}</span>
                </div>
              </div>

              <Form>

                <div class="container p-4 text-left space-y-3">

                  <div class="flex flex-wrap -mx-2">
                    <div class="w-full text-white px-2 py-2 text-center rounded-lg shadow-sm uppercase text-lg"
                      :style="{ backgroundColor: detalleAgenda.colorEstado }">
                      {{ detalleAgenda.descripcionEstado }}
                    </div>
                  </div>

                  <div class="flex flex-col -mx-2 text-lg uppercase space-y-1">

                    <div class="mx-auto" v-if="detalleAgenda.contraparte">
                      <!-- CON FOTO -->
                      <img v-if="detalleAgenda.contraparte.foto" :src="detalleAgenda.contraparte.foto"
                        class="w-24 h-24 flex-shrink-0 rounded-lg border border-[#424c42] object-cover" />
                      <!-- SIN FOTO (iniciales) -->
                      <div v-else
                        class="w-16 h-16 flex-shrink-0 rounded-lg border border-[#424c42] flex items-center justify-center font-semibold text-xl text-gray-700 bg-[radial-gradient(circle,_white_0%,_#d1d5db_100%)]">
                        <span class="leading-none text-gray-500 mb-1 text-xl">
                          {{ iniciales(detalleAgenda.contraparte.nombre, detalleAgenda.contraparte.apellido) }}
                        </span>
                      </div>
                    </div>

                    <span class="w-full text-center text-xl" v-if="detalleAgenda.contraparte">{{
                      detalleAgenda.contraparte?.nombre + " " + detalleAgenda.contraparte?.apellido }}</span>
                    <span class="w-full text-center text-xs text-gray-500 pt-2"
                      v-if="detalleAgenda.empresa">Empresa</span>
                    <span class="w-full text-center text-sm text-gray-600" v-if="detalleAgenda.empresa">{{
                      detalleAgenda.empresa?.nombreFantasia || detalleAgenda.empresa?.razonSocial || 'Sin empresa'
                      }}</span>
                    <span class="w-full text-center text-sm text-gray-600 pt-2"
                      v-if="detalleAgenda.empresa?.pabellon">Pabellón : {{ detalleAgenda.empresa?.pabellon }}</span>
                    <span class="w-full text-center text-sm text-gray-600 pt-2"
                      v-if="detalleAgenda.empresa?.stand">Stand : {{ detalleAgenda.empresa?.stand }}</span>
                    <span class="w-full text-center text-xs text-gray-500 pt-2"
                      v-if="detalleAgenda.observaciones">Observaciones</span>
                    <span class="w-full text-center text-lg text-gray-600 line-clamp-2">{{ detalleAgenda.observaciones
                      }}</span>
                  </div>

                  <Field name="motivoCambioEstado" v-slot="{ field, errors }" v-model="motivoCambioEstado">
                    <Textarea v-bind="field" rows="4" type="text" :placeholder="$t('label.motivo.cambio.estado')"
                      class="input-base w-full border border-gray-300 p-2 text-gray-500 !shadow-md rounded-xl mt-4"
                      :class="{ 'bg-gray-50': errors.length === 0, 'bg-green-50 border-green-500 text-green-900 placeholder-green-700 focus:ring-green-500 focus:border-green-500': errors.length === 0 && field.value !== '', 'bg-red-50 border-red-500 text-red-900 placeholder-red-700 focus:ring-red-500 focus:border-red-500': errors.length > 0 }" />
                  </Field>

                </div>



              </Form>

              <div class="p-3 flex flex-col md:flex-row gap-2 justify-end w-full mt-2 bg-gray-100">

                <a @click="cancelar()" v-if="puedeCancelar"
                  class="cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
                  <font-awesome-icon :icon="['far', 'fa-bell-slash']" /> {{ $t('boton.cancelar.solicitud') }}
                </a>
                <a @click="rechazar()" v-if="puedeRechazar"
                  class="cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
                  <font-awesome-icon :icon="['fas', 'fa-ban']" /> {{ $t('boton.rechazar') }}
                </a>
                <a @click="confirmar()" v-if="puedeConfirmar"
                  class="cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
                  <font-awesome-icon :icon="['fas', 'fa-check']" /> {{ $t('boton.confirmar') }}
                </a>
                <a @click="desbloquear()" v-if="puedeDesbloquear"
                  class="cursor-pointer px-6 text-sm font-bold text-[#424c42] bg-transparent py-3 border border-[#424c42] shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
                  <font-awesome-icon :icon="['fas', 'fa-lock-open']" /> {{ $t('boton.desbloquear') }}
                </a>

                <a @click="closeDialog(false)"
                  class="cursor-pointer px-6 text-sm font-bold text-red-500 bg-transparent py-3 border border-red-500 shadow-md rounded-xl transform transition-transform duration-200 hover:scale-105 active:scale-95">
                  <font-awesome-icon :icon="['fas', 'fa-xmark']" /> {{ $t('boton.cerrar') }}
                </a>

              </div>
            </BlockUI>


          </div>
        </div>

      </div>
    </div>
  </Teleport>

</template>

<script lang="ts">
import { defineComponent, PropType } from 'vue';
import { Form, Field } from 'vee-validate';

import { formatDate } from 'date-fns';

import meetingService, { ConfiguracionMeeting } from 'qreventos-suite/meeting';

import Swal from 'sweetalert2'
import BlockUI from 'primevue/blockui';
import ProgressSpinner from 'primevue/progressspinner';

import { DetalleAgenda, Acreditado } from 'qreventos-suite/src/services/suite.interfaces';
import seguridadServices from '@/services/seguridad.services';
import configuracionMeetingService from '@/services/configuracion.merting.services';

export default defineComponent({
  components: {
    Form, Field,
    BlockUI, ProgressSpinner
  },
  props: {
    closeFunction: {
      type: Function,
      required: false
    },
    detalleAgenda: {
      type: {} as PropType<DetalleAgenda>,
      required: true,
      deep: true
    },
    acreditado: {
      type: {} as PropType<Acreditado>,
      required: true
    },
  },
  data() {
    return {
      blocked: false,
      observaciones: '',
      motivoCambioEstado: ''
    };
  },
  computed: {
    puedeRechazar(): boolean {
      const pendienteSolicitado = (this.acreditado.id !== this.detalleAgenda.acreditadoSolicitante?.id) && (this.detalleAgenda.idDetalleEstadoAgenda == 1);
      const confirmadaAmbos = (this.detalleAgenda.idDetalleEstadoAgenda == 2);
      return pendienteSolicitado || confirmadaAmbos;
    },
    puedeConfirmar(): boolean {
      return (this.acreditado.id !== this.detalleAgenda.acreditadoSolicitante?.id) && (this.detalleAgenda.idDetalleEstadoAgenda == 1);
    },
    puedeDesbloquear(): boolean {
      return (this.acreditado.id === this.detalleAgenda.acreditadoSolicitante?.id) && this.detalleAgenda.idDetalleEstadoAgenda == 4;
    },
    puedeCancelar(): boolean {
      return (this.acreditado.id === this.detalleAgenda.acreditadoSolicitante?.id) && this.detalleAgenda.idDetalleEstadoAgenda == 1;
    }
  },
  methods: {
    formatDate,
    iniciales(nombre: string, apellido: string): string {
      const n = nombre?.charAt(0) || '';
      const a = apellido?.charAt(0) || '';
      return (n + a).toUpperCase();
    },
    closeDialog(reload: boolean = false) {
      if (this.closeFunction) {
        this.closeFunction(reload);
      }
    },
    async rechazar() {
      await this.aceptar(1);
    },
    async confirmar() {
      await this.aceptar(2);
    },
    async desbloquear() {
      await this.aceptar(3);
    },
    async cancelar() {
      await this.aceptar(4);
    },
    async aceptar(accion: number) {
      try {
        console.log("Estado : " + this.motivoCambioEstado)

        this.blocked = true;

        const hash: string = seguridadServices.getLocalHash() as string;
        const configuracionMeeting: ConfiguracionMeeting = configuracionMeetingService.get() as ConfiguracionMeeting;

        switch (accion) {
          case 1: // Rechazar
            await meetingService.cambiarEstado(configuracionMeeting.evento.id, hash, this.detalleAgenda.idAgenda, 3, this.motivoCambioEstado);
            break;
          case 2: // Confirmar              
            await meetingService.cambiarEstado(configuracionMeeting.evento.id, hash, this.detalleAgenda.idAgenda, 2, this.motivoCambioEstado);
            break;
          case 3: // Desbloquear
            await meetingService.desbloquear(configuracionMeeting.evento.id, hash, this.detalleAgenda.idAgenda);
            break;
          case 4: // Cancelar
            await meetingService.cancelar(configuracionMeeting.evento.id, hash, this.detalleAgenda.idAgenda);
            break;
        }

        this.closeDialog(true);
      }
      catch (error) {
        this.blocked = false;
        Swal.fire({ title: "Error", text: 'Error [' + error + ']', icon: "error" });
      } finally {
        this.blocked = false;
      }
    },
  },
  async mounted() {
    document.body.style.overflow = "hidden";
  },
  unmounted() {
    document.body.style.overflow = "";
  }
});
</script>